import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'


// sing_in
export const userSingIn = (creds) => (dispatch) => {
  let payload = {...creds, 'device_type': 'web'}
  dispatch(addEventLog(payload, CONSTANTS.LOGIN_REQUEST))
  dispatch({ type: CONSTANTS.LOGIN_REQUEST })
  return postRequest(APICONFIG.singInUrl, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.LOGIN_SUCCESS))
    dispatch({ type: CONSTANTS.LOGIN_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.LOGIN_FAILURE))
    dispatch({ type: CONSTANTS.LOGIN_FAILURE })
    return err
  })
}

// sing_up

export const userSingUp = (creds) => (dispatch) => {
  let payload = {...creds, 'device_type': 'web'}
  dispatch(addEventLog(payload, CONSTANTS.SINGUP_REQUEST))
  dispatch({ type: CONSTANTS.SINGUP_REQUEST })
  return postRequest(APICONFIG.singupUrl, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SINGUP_SUCCESS))
    dispatch({ type: CONSTANTS.SINGUP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SINGUP_FAILURE))
    dispatch({ type: CONSTANTS.SINGUP_FAILURE })
    return err
  })
}

export const sendEmailResetPassword = (payload) => (dispatch) => {
  let payloadResetPass = {...payload, 'device_type': 'web'}
  dispatch(addEventLog(payloadResetPass, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_REQUEST))
  dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_REQUEST })
  return postRequest(APICONFIG.sendEmailResetPassword, payloadResetPass).then((res) => {
    let resObject = { ...payloadResetPass, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_SUCCESS))
    dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payloadResetPass, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SEND_EMAIL_RESET_PASSWORD_FAILURE))
    dispatch({ type: CONSTANTS.SEND_EMAIL_RESET_PASSWORD_FAILURE })
    return err
  })
}


// RESET PASSWORD
export const UpdateUserpassword = (payload) => (dispatch) => {
  let payloadUpdatePass = {...payload, 'device_type': 'web'}
  dispatch(addEventLog(payloadUpdatePass, CONSTANTS.RESET_PASSWORD_REQUEST))
  dispatch({ type: CONSTANTS.RESET_PASSWORD_REQUEST })
  return postRequest(APICONFIG.resetPassword, payloadUpdatePass).then((res) => {
    let resObject = { ...payloadUpdatePass, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.RESET_PASSWORD_SUCCESS))
    dispatch({ type: CONSTANTS.RESET_PASSWORD_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payloadUpdatePass, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.RESET_PASSWORD_FAILURE))
    dispatch({ type: CONSTANTS.RESET_PASSWORD_FAILURE })
    return err
  })
}


export const handleUserLogOut = () => {
  localStorage.clear()
}